/**
 * Recorridos por pantalla: un archivo por área con su mapa «patrón de ruta → recorrido». Para agregar
 * una pantalla, ver README.md de esta carpeta.
 */
import { adminBTours } from './admin-b';
import { adminATours } from './admin-a';
import { homeTours } from './home';
import { inventoryTours } from './inventory';
import { loanTours } from './loans';
import { loanMoreTours } from './loans-more';
import { officeTours } from './offices';
import { processTours } from './processes';
import { reportTours } from './reports';
import { reportMoreTours } from './reports-more';
import type { ScreenTour, ScreenTourMap } from './types';

export type { ScreenTour, ScreenTourMap, ScreenTourStep } from './types';

export const screenTours: ScreenTourMap = { ...homeTours, ...officeTours, ...loanTours, ...reportTours, ...inventoryTours, ...adminBTours, ...reportMoreTours, ...adminATours, ...loanMoreTours, ...processTours };

const clean = (path: string) => (path.length > 1 ? path.replace(/\/+$/, '') : path) || '/';

const matches = (pattern: string, path: string) => {
  const a = clean(pattern).split('/');
  const b = clean(path).split('/');
  return a.length === b.length && a.every((seg, i) => seg.startsWith(':') ? b[i] !== '' : seg === b[i]);
};

/** Recorrido de la pantalla abierta: primero la ruta exacta, luego un patrón con `:parámetros`. */
export const findScreenTour = (pathname: string): ScreenTour | null => {
  const path = clean(pathname);
  if (screenTours[path]) return screenTours[path];
  const pattern = Object.keys(screenTours).find((p) => p.includes(':') && matches(p, path));
  return pattern ? screenTours[pattern] : null;
};
